module.exports = __webpack_public_path__ + "static/img/3areaB_10.e68df09.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_10.png
// module id = 1161
// module chunks = 1